import { useEffect, useState } from "react";
import { TriangleSmallIcon } from "@icons";
import { Button } from "@design-system/Button/Button";
import { Link } from "@design-system/Link/Link";
import importerStyles from "@components/importer/ImporterPage.module.scss";

export interface AccrualDraftReviewTaskItem {
    id: string;
    message: string;
    onSelect?: () => void;
    onSkip?: () => void;
}

interface Props {
    tasks: AccrualDraftReviewTaskItem[];
    onTaskChange?: (task: AccrualDraftReviewTaskItem | undefined) => void;
}

export const AccrualDraftReviewTasks: React.FC<Props> = ({
    tasks,
    onTaskChange,
}) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const safeIndex = Math.min(currentIndex, tasks.length - 1);
    const task = tasks[safeIndex];

    useEffect(() => {
        onTaskChange?.(task);
    }, [onTaskChange, task]);

    if (!task) {
        return null;
    }

    return (
        <>
            <div className={importerStyles.commandBarNav}>
                <Button
                    variant="primary"
                    size="md"
                    iconOnly
                    aria-label="Previous review task"
                    className={importerStyles.commandBarNavLeft}
                    onClick={() => setCurrentIndex(Math.max(0, safeIndex - 1))}
                    disabled={safeIndex === 0}
                >
                    <TriangleSmallIcon className="icon-rotate-90" />
                </Button>
                <Button
                    variant="primary"
                    size="md"
                    iconOnly
                    aria-label="Next review task"
                    className={importerStyles.commandBarNavRight}
                    onClick={() => setCurrentIndex(safeIndex + 1)}
                    disabled={safeIndex === tasks.length - 1}
                >
                    <TriangleSmallIcon className="icon-rotate-270" />
                </Button>
            </div>
            <div className={importerStyles.commandBarMessage}>
                <span>
                    Review task {safeIndex + 1} of {tasks.length}
                </span>
                <span className={importerStyles.commandBarDot}>&middot;</span>
                <span>
                    {task.onSelect ? (
                        <Link onClick={task.onSelect}>{task.message}</Link>
                    ) : (
                        task.message
                    )}
                </span>
                {task.onSkip ? (
                    <>
                        <span className={importerStyles.commandBarDot}>
                            &middot;
                        </span>
                        <Link onClick={task.onSkip}>Skip</Link>
                    </>
                ) : null}
            </div>
        </>
    );
};
